import { IconSvgProps } from '../types';

export const Laptop = ({ size }: IconSvgProps) => (
  <svg
    id="icon-device-laptop"
    width={size}
    height={size}
    viewBox="0 0 64 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path
          d="M0,41.72 C0,43.01 1.04,44.05 2.32,44.05 L61.68,44.05 C62.96,44.05 64,43.01 64,41.72 C64,40.44 62.96,39.4 61.68,39.4 L2.32,39.4 C1.04,39.4 0,40.44 0,41.72 Z"
          opacity="0.5"
        />
        <path d="M58.58,36.56 C58.58,38.27 57.19,39.66 55.48,39.66 L8.52,39.66 C6.81,39.66 5.42,38.27 5.42,36.56 L5.42,7.14 C5.42,3.72 8.19,0.95 11.61,0.95 L52.39,0.95 C55.81,0.95 58.58,3.72 58.58,7.14 L58.58,36.56 Z M53.94,5.59 L10.07,5.59 L10.07,34.76 L53.94,34.76 L53.94,5.59 Z" />
        <polygon
          opacity="0.5"
          points="10.06 5.6 53.94 5.6 53.94 34.76 10.06 34.76"
        />
      </g>
    </g>
  </svg>
);
